var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _path31, _path32, _path33, _path34, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommingSoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 509,
    viewBox: "0 0 375 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375 176L0 257V508.226L375 426V176Z",
    fill: "#1162FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0399 83.8807C96.602 92.8481 89.7587 99.8025 77.9939 102.299C65.1179 105.038 59.6931 98.9724 59.6931 89.4952C59.6931 78.0767 67.1245 64.5341 83.2227 61.1158C94.8111 58.6517 100.765 63.3968 101.033 71.5734L88.9091 74.1551C88.8633 71.5407 87.6018 68.3185 82.7129 69.3642C75.3468 70.9263 72.3468 80.58 72.3468 86.7827C72.3468 91.3579 73.7847 94.907 79.2031 93.7501C83.0266 92.9397 85.3731 90.5932 87.092 86.4363L99.0399 83.8807Z",
    fill: "#1162FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.276 64.5013C147.276 76.9197 139.263 89.2728 123.145 92.6977C110.223 95.4493 104.229 89.2663 104.229 79.8021C104.229 68.8216 111.295 55.1352 128.047 51.5731C140.805 48.8672 147.276 55.0045 147.276 64.5013ZM116.883 77.0308C116.883 82.4035 119.086 85.2597 124.073 84.2205C131.759 82.5865 134.707 73.1092 134.707 66.3314C134.707 62.0242 132.936 58.7104 127.432 59.8803C120.073 61.4228 116.883 70.9262 116.883 77.0308Z",
    fill: "#1162FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.845 65.3707C188.152 59.0111 189.93 51.2594 191.172 46.5012H191.06C187.904 54.6843 183.119 65.3707 176.727 80.4101L166.923 82.5016C166.688 70.4753 166.328 59.436 166.224 51.7039H166.132C165.439 56.3183 164.315 64.0177 162.916 70.8544L160.237 83.9264L149.603 86.1879L157.733 46.1483L174.727 42.5273C175.093 50.7888 175.596 61.5667 175.381 66.6517H175.452C177.655 60.7693 182.596 49.4947 186.838 39.9717L203.832 36.3573L195.708 76.4165L184.093 78.8872L186.845 65.3707Z",
    fill: "#1162FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.401 31.9717L216.283 72.0309L204.466 74.5408L212.59 34.4815L224.401 31.9717Z",
    fill: "#1162FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.911 70.1943L233.035 30.1351L246.924 27.1808C252.231 39.9783 253.885 45.2137 255.192 49.9261L255.381 49.8869C255.702 46.3117 257.238 38.462 258.584 31.8344L260.114 24.3834L270.806 22.1023L262.689 62.1615L249.558 64.9524C247.826 59.802 242.329 44.4293 241.126 39.7299L240.963 39.7691C240.401 44.4947 239.002 51.1157 237.584 58.1746L235.623 67.9133L224.911 70.1943Z",
    fill: "#1162FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.46 52.2267L301.421 53.9325C301.281 52.8244 301.267 51.7038 301.382 50.5927C298.996 53.5339 295.866 55.9914 289.29 57.3901C277.8 59.8346 273.003 52.8933 273.003 44.0697C273.003 32.1611 281.356 18.991 296.833 15.7034C308.441 13.2328 314.323 17.5465 314.983 24.3309L303.075 26.8604C302.846 25.0564 301.434 22.8211 296.343 23.9061C289.584 25.3375 285.604 33.6644 285.604 40.8997C285.604 46.6906 287.865 49.3965 292.794 48.3508C299.009 47.0436 300.421 42.4684 300.977 40.2984L301.036 40.1219L293.192 41.7821L295.434 32.9258L314.127 28.9584L309.46 52.2267Z",
    fill: "#1162FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.054 135.157C112.521 137.753 114.638 139.128 118.946 138.226C122.186 137.52 124.641 136.127 124.641 133.592C124.641 131.671 123.506 130.818 118.001 130.579C108.421 130.162 105.193 127.946 105.193 122.914C105.193 115.691 111.471 109.554 121.505 107.424C133.558 104.859 137.706 109.621 137.958 114.942L127.452 117.176C127.169 115.501 125.985 113.758 121.462 114.721C118.651 115.335 116.958 116.998 116.958 118.858C116.958 120.84 118.608 121.153 123.53 121.312C133.803 121.687 136.498 124.614 136.498 129.708C136.498 136.851 130.146 143.209 118.461 145.7C107.838 147.959 102.014 145.013 101.364 137.428L112.054 135.157Z",
    fill: "#1162FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.156 110.714C181.156 122.374 173.632 133.973 158.498 137.188C146.36 139.772 140.738 133.966 140.738 125.08C140.738 114.77 147.372 101.919 163.101 98.5749C175.062 96.0342 181.156 101.797 181.156 110.714ZM152.601 122.478C152.601 127.523 154.669 130.204 159.351 129.229C166.568 127.694 169.336 118.796 169.336 112.432C169.336 108.388 167.673 105.276 162.506 106.375C155.596 107.823 152.601 116.728 152.601 122.478Z",
    fill: "#1162FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225.673 101.251C225.673 112.911 218.155 124.51 203.015 127.725C190.883 130.309 185.255 124.503 185.255 115.617C185.255 105.307 191.895 92.4565 207.624 89.1119C219.585 86.5712 225.673 92.3337 225.673 101.251ZM197.124 113.015C197.124 118.06 199.186 120.741 203.875 119.766C211.092 118.231 213.859 109.333 213.859 102.969C213.859 98.9248 212.202 95.8134 207.035 96.9119C200.125 98.3602 197.124 107.283 197.124 113.015Z",
    fill: "#1162FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.882 121.619L235.51 84.0059L248.551 81.232C253.534 93.2481 255.087 98.1576 256.314 102.588L256.486 102.552C256.793 99.1947 258.235 91.8243 259.499 85.6015L260.935 78.5993L271 76.4636L263.378 114.077L251.061 116.697C249.435 111.861 244.274 97.4273 243.145 93.0149L242.985 93.0455C242.463 97.4887 241.144 103.705 239.818 110.333L237.977 119.477L227.882 121.619Z",
    fill: "#1162FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M269.871 131.99L96.9144 168.247V171.733L269.871 135.476V131.99Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M269.871 124L96.9144 160.257V163.743L269.871 127.486V124Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8284 314.116L353.623 241.94",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M152.468 311.621C159.586 309.441 163.947 303.072 162.209 297.397C160.471 291.722 153.291 288.888 146.173 291.068C139.056 293.248 134.694 299.616 136.433 305.292C138.171 310.967 145.35 313.801 152.468 311.621Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M180.368 258.436L162.354 263.953C156.194 265.84 152.723 272.349 154.604 278.491L158.769 292.089L136.252 298.986L131.575 283.717C126.294 266.473 136.034 248.201 153.332 242.904L173.698 236.666C179.692 234.83 186.042 238.155 187.922 244.116C189.828 250.148 186.433 256.578 180.368 258.436Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8284 373.365L353.623 301.189",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M169.951 288.262L252.501 380.906H298.683L212.362 288.262H169.951Z",
    fill: "#1782FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176.642 288.262C174.052 288.262 172.679 291.324 174.402 293.258L251.606 379.901C252.175 380.54 252.99 380.906 253.846 380.906H291.787C294.409 380.906 295.769 377.779 293.982 375.86L213.252 289.217C212.684 288.608 211.889 288.262 211.057 288.262H176.642Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M170.03 291.271C170.028 289.614 171.368 288.262 173.024 288.262C179.466 288.262 195.205 288.262 209.478 288.262C211.134 288.262 212.476 289.607 212.48 291.264C212.585 333.799 214.195 372.288 153.885 372.288C134.3 372.288 123.348 372.288 118.541 372.288C116.884 372.288 115.55 370.944 115.55 369.288V342.389C115.55 340.732 116.89 339.389 118.547 339.389C123.017 339.389 132.519 339.389 147.26 339.389C170.604 339.389 170.075 327.094 170.03 291.271Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M199.172 195.39C199.172 195.39 208.031 198.494 208.031 210.355C208.031 210.355 207.861 212.239 208.999 212.553C211.868 213.351 211.129 216.689 209.062 217.079C209.062 217.079 208.367 234.399 193.748 234.399H178.569L179.107 226.32C179.107 226.32 165.845 216.666 171.857 209.763C177.869 202.859 199.172 195.39 199.172 195.39Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M262.009 236.39C256.745 231.126 249.076 230.261 244.879 234.458C240.682 238.655 241.546 246.325 246.81 251.589C252.074 256.853 259.744 257.717 263.941 253.52C268.138 249.323 267.273 241.653 262.009 236.39Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M190.8 308.149H169.252V252.694C169.252 240.831 178.9 231.213 190.8 231.213C202.701 231.213 212.349 240.831 212.349 252.694V286.67C212.349 298.532 202.701 308.149 190.8 308.149Z",
    fill: "#5C94FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M200.562 221.958C202.482 224.123 205.206 225.497 208.16 225.703",
    stroke: "#1162FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187.38 187.666C187.38 187.666 176.391 184.39 168.17 194.541C161.706 204.236 160.172 214.743 169.785 224.704L178.532 234.209L179.111 234.438L180.723 223.088C180.806 222.521 180.431 221.98 179.856 221.854C177.796 221.393 175.528 219.734 175.528 214.343C175.528 207.863 181.516 207.678 183.149 211.785C183.308 212.186 183.858 212.246 184.089 211.88L187.997 205.707C187.997 205.707 201.43 205.897 207.475 197.873C213.519 189.848 208.327 195.621 202.796 190.615C195.525 184.908 187.38 187.666 187.38 187.666Z",
    fill: "#0041E2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M197.983 241.048L211.494 253.702C216.311 258.214 225.523 260.946 230.048 256.144L239.405 246.215C239.518 246.096 255.136 259.104 255.136 259.104L253.734 260.592C236.064 279.341 206.494 280.261 187.684 262.646L182.342 257.643C177.774 253.364 177.518 246.213 181.772 241.62C186.081 236.974 193.358 236.717 197.983 241.048Z",
    fill: "#1162FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.154 238.977L214.884 251.835C219.582 256.234 226.966 256.004 231.378 251.321L241.146 240.957L258.309 257.032L247.34 268.67C234.954 281.814 214.224 282.458 201.039 270.11L185.515 255.571C180.947 251.292 180.691 244.14 184.945 239.548C189.251 234.903 196.529 234.646 201.154 238.977Z",
    fill: "url(#paint4_linear_0_1)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8284 438L353.623 365.824",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M308.187 418.964L264.922 418.964C258.603 418.964 253.483 413.826 253.483 407.489L253.483 393.207C253.483 386.413 258.972 380.906 265.745 380.906L290.601 380.906C305.416 380.906 317.424 392.951 317.424 407.812L317.424 409.7C317.421 414.816 313.287 418.964 308.187 418.964Z",
    fill: "#4181FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 253,
    y: 380,
    width: 65,
    height: 39
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M308.142 418.964L264.878 418.964C258.558 418.964 253.438 413.826 253.438 407.489L253.438 393.207C253.438 386.413 258.928 380.906 265.7 380.906L290.557 380.906C305.371 380.906 317.379 392.951 317.379 407.812L317.379 409.7C317.377 414.816 313.242 418.964 308.142 418.964Z",
    fill: "#1162FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.095 378.615L299.25 394.509C297.722 396.043 295.242 396.043 293.711 394.509C292.182 392.976 292.182 390.488 293.711 388.953L309.556 373.058C311.084 371.525 313.564 371.525 315.095 373.058C316.624 374.594 316.624 377.082 315.095 378.615Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.167 387.265L308.322 403.16C306.794 404.693 304.314 404.693 302.783 403.16C301.254 401.626 301.254 399.139 302.783 397.603L318.628 381.709C320.157 380.175 322.637 380.175 324.167 381.709C325.698 383.244 325.698 385.732 324.167 387.265Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M202.193 212.698H202.128C201.908 212.698 201.73 212.516 201.73 212.292V208.794C201.73 208.57 201.908 208.389 202.128 208.389H202.193C202.413 208.389 202.592 208.57 202.592 208.794V212.292C202.592 212.516 202.413 212.698 202.193 212.698Z",
    stroke: "#1162FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M205.224 204.183C204.102 203.117 202.344 202.624 200.546 203.029C198.748 203.434 197.374 204.633 196.817 206.077",
    stroke: "#1162FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8456 387.178V343.914C77.8456 337.594 82.9839 332.474 89.3209 332.474H103.603C110.397 332.474 115.904 337.964 115.904 344.737V369.593C115.904 384.407 103.859 396.415 88.9975 396.415H87.1091C81.9934 396.413 77.8456 392.278 77.8456 387.178Z",
    fill: "#3B7EFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 332,
    width: 39,
    height: 65
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8456 387.133V343.869C77.8456 337.549 82.9839 332.429 89.3209 332.429H103.603C110.397 332.429 115.904 337.919 115.904 344.692V369.548C115.904 384.363 103.859 396.37 88.9975 396.37H87.1091C81.9934 396.368 77.8456 392.233 77.8456 387.133Z",
    fill: "#1162FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.195 394.087L102.3 378.242C100.767 376.713 100.767 374.233 102.3 372.703C103.834 371.174 106.321 371.174 107.857 372.703L123.752 388.548C125.285 390.076 125.285 392.556 123.752 394.087C122.216 395.615 119.728 395.615 118.195 394.087Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.544 403.159L93.6496 387.314C92.1162 385.786 92.1162 383.306 93.6496 381.775C95.183 380.246 97.6707 380.246 99.2063 381.775L115.101 397.62C116.634 399.148 116.634 401.628 115.101 403.159C113.565 404.69 111.077 404.69 109.544 403.159Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 73.6187,
    y1: 151.862,
    x2: 291.663,
    y2: 151.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1162FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1162FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 73.6187,
    y1: 143.871,
    x2: 291.663,
    y2: 143.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1162FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1162FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 153.315,
    y1: 242.909,
    x2: 170.224,
    y2: 305.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1162FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 185.571,
    y1: 296.88,
    x2: 287.371,
    y2: 362.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 220.112,
    y1: 235.89,
    x2: 220.112,
    y2: 278.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5891FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EBFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommingSoon);
export default __webpack_public_path__ + "static/media/CommingSoon.b926ea57.svg";
export { ForwardRef as ReactComponent };